import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import {
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  CircularProgress,
  Menu,
  Grid,
  TextField,
  IconButton,
  Typography,
  Box,
  Chip,
  Avatar,
  makeStyles,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  InputLabel,
  MenuItem,
  FormHelperText,
  Select,
  Tabs,
  Tab,
  Divider,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Close as CloseIcon,
  DirectionsCar as CarIcon,
  Build as BuildIcon,
  Speed as SpeedIcon,
  DateRange as DateIcon,
  VpnKey as VinIcon,
  LocalShipping as TruckIcon,
  Phone as PhoneIcon,
  Category as CategoryIcon,
  Business as BusinessIcon,
  Group as GroupIcon,
  Assignment as AssignmentIcon,
  LocationOn as LocationIcon,
} from '@material-ui/icons';
import QRCode from 'qrcode';
import moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import AssignedEntityComponent from '../Entities/AssignedEntityComponent';
import PhotoUploadComponent from '../Uploads/PhotoUploadComponent';
import RepairComponent from './RepairsComponent';
import AddRepairButton from './NewRepair';
import EquipmentMaintenanceHistory from './MtcAndRepair/EquipmentMtcHistory'
import VehicleDamageViewer from './MtcAndRepair/VehicleDamageViewer';
import {
  formattedItem,
  
} from './KeyInputs'
import {
  TypesOfKeys
} from './AddEquipmentModal'

const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: theme.spacing(3),
  },
  header: {
    position: 'relative',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.primary.contrastText,
  },
  imageSection: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  mainImage: {
    width: 300,
    height: 200,
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
  },
  qrCode: {
    width: 120,
    height: 120,
  },
  statusChip: {
    marginTop: theme.spacing(1),
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  tabPanel: {
    padding: theme.spacing(2),
  },
  statsGrid: {
    marginBottom: theme.spacing(3),
  },
  statCard: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
  },
  statIcon: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
    padding: theme.spacing(1),
    borderRadius: '50%',
  },
  fieldGroup: {
    marginBottom: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  formControl: {
    margin: theme.spacing(3),
  },
}));

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box className={other.className}>{children}</Box>}
    </div>
  );
}

const EquipmentModal = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);

  const equipmentTypes = [
    'Vehicle',
    'Trailer',
    'Mower',
    'Trimmer',
    'Jackhammer',
    'Cell Phone',
    'Tablet',
    'Key',
    'Keycard',
    'Other'
  ];

  const divisions = [
    'Customer Service',
    'Specialty',
    'Irrigation and Lighting',
    'Maintenance',
    'Landscape Install',
    'Hardscape',
    'Pool/Spa',
    'Yard',
    'Commercial',
    'ADOT',
    'Maricopa County'
  ];

  const [state, setState] = React.useState({
    equipment: {},
    isActive: false,
    assignedCrew: {},
    entity: {},
    qrCode: '',
    counter: 0,
    customQR: '',
    tankState: null,
    recentActivities: [],
    tankConfig: {
      cleanTankCapacity: 300,
      mixTankCapacity: 200,
      calibrationRate: 20
    },
    loadingTankData: false,
    showAllActivities: false,
    initialTankDataLoaded: false
  });

  React.useEffect(() => {
    if (props.equipment && props.equipment._id) {
      console.log('Set it', props.equipment)

      let newState = {
        equipment: props.equipment,
        isActive: props.equipment.isActive,
        initialTankDataLoaded: false,
        tankState: null,
        recentActivities: []
      };

      if (props.equipment.crew) {
        let ourIndex = props.crews.map(function (e) {
          return e._id;
        }).indexOf(props.equipment.crew);
        newState.assignedCrew = props.crews[ourIndex];
      }

      setState(prev => ({
        ...prev,
        ...newState
      }));

      // Immediately fetch tank data if this is a spray truck
      if (props.equipment.isSprayTruck) {
        console.log('Equipment is spray truck, fetching tank data...');
        // Small delay to ensure state has updated
        setTimeout(() => {
          fetchTankDataForEquipment(props.equipment._id);
        }, 100);
      } else {
        console.log('Doublecheck...')
        setTimeout(() => {
          fetchTankDataForEquipment(props.equipment._id);
        }, 1000);
      }
    }
  }, [props.equipment?._id]);

  React.useEffect(() => {
    if (state.equipment && state.equipment._id) {
      let qrURL = `https://dflportal.com/qr/equipment/${state.equipment._id}`;
      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/png',
        quality: 0.5,
        margin: 3,
        color: {
          dark: "#000",
          light: "#FFF",
        }
      };
      QRCode.toDataURL(qrURL, opts, function (err, url) {
        if (err) throw err;
        setState({...state, qrCode: url, counter: state.counter++ });
      });
    }
  }, [state.equipment]);

  const fetchTankDataForEquipment = async (equipmentId) => {
    if (!equipmentId) {
      console.log('No equipment ID provided, skipping tank data fetch');
      return;
    }

    console.log('Fetching tank data for equipment:', equipmentId);
    setState(prev => ({ ...prev, loadingTankData: true }));

    try {
      // Fetch tank state
      const tankStateResponse = await axios.get(
        `${props.url}/api/equipment/getTankState?equipmentId=${equipmentId}`
      );

      // Fetch recent activities
      const activitiesResponse = await axios.get(
        `${props.url}/api/equipment/getTankActivities?equipmentId=${equipmentId}&limit=10`
      );

      const newState = {
        tankState: tankStateResponse.data.tankState,
        recentActivities: activitiesResponse.data.activities || [],
        loadingTankData: false,
        initialTankDataLoaded: true
      };

      // Update tank config from existing tank state (only on initial load)
      if (tankStateResponse.data.tankState && tankStateResponse.data.tankState.tanks) {
        const cleanTank = tankStateResponse.data.tankState.tanks.find(t => t.type === 'clean');
        const mixTank = tankStateResponse.data.tankState.tanks.find(t => t.type === 'mix');

        newState.tankConfig = {
          cleanTankCapacity: cleanTank?.maxCapacity || 300,
          mixTankCapacity: mixTank?.maxCapacity || 200,
          calibrationRate: tankStateResponse.data.tankState.calibrationRate || 20
        };

        console.log('Loaded existing tank state:', {
          cleanCapacity: cleanTank?.maxCapacity,
          cleanVolume: cleanTank?.currentVolume,
          mixCapacity: mixTank?.maxCapacity,
          mixVolume: mixTank?.currentVolume,
          calibrationRate: tankStateResponse.data.tankState.calibrationRate
        });
      } else {
        console.log('No tank state found for this equipment');
      }

      setState(prev => ({
        ...prev,
        ...newState
      }));
    } catch (error) {
      console.error('Error fetching tank data:', error);
      setState(prev => ({
        ...prev,
        loadingTankData: false,
        initialTankDataLoaded: true // Mark as loaded even on error to prevent retry loops
      }));
    }
  };

  const fetchTankData = async () => {
    return fetchTankDataForEquipment(state.equipment?._id);
  };

  const handleSubmit = async () => {
    setLoading(true);
    let equip = state.equipment;
    let obj = { equipment: equip };

    try {
      // First update the equipment
      const equipmentResponse = await axios({
        method: 'post',
        url: `${props.url}/api/equipment/updateEquipment`,
        data: obj,
      });

      if (!equipmentResponse.data._id) {
        props.notification({
          type: 'warning',
          title: 'Uh Oh!',
          message: equipmentResponse.data.message
        });
        setLoading(false);
        return;
      }

      // If spray truck is enabled and we need to initialize tank state
      if (equip.isSprayTruck) {
        try {
          const tankResponse = await axios.post(
            `${props.url}/api/equipment/toggleSprayTruck`,
            {
              equipmentId: equip._id,
              isSprayTruck: true,
              tankConfig: state.tankConfig
            }
          );

          if (tankResponse.data.success) {
            // Reset the flag to allow fetching fresh data
            setState(prev => ({ ...prev, initialTankDataLoaded: false }));

            // Refresh tank data to show updated state
            await fetchTankData();

            props.notification({
              type: 'success',
              title: 'Equipment Updated!',
              message: state.tankState
                ? 'Spray truck configuration updated successfully'
                : 'Spray truck configuration saved successfully'
            });
          }
        } catch (tankError) {
          console.error('Error setting up tank state:', tankError);
          props.notification({
            type: 'warning',
            title: 'Partial Success',
            message: 'Equipment updated but tank setup failed. Please try again.'
          });
        }
      } else {
        props.notification({
          type: 'success',
          title: 'Saved Changes to that Equipment!',
          message: 'Well Done!!'
        });
      }

      props.updateParent('update', equipmentResponse.data);
      setLoading(false);
    } catch (err) {
      console.error('Error saving equipment:', err);
      props.notification({
        type: 'error',
        title: 'Error',
        message: 'Failed to save equipment'
      });
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    console.log('Close modal - can we change url??', props)
    props.updateParent('closeModal');
  };

  const updateEquipmentDivision = (event, value) => {
    setState({...state, equipment: {...state.equipment, division: value}});
  };

  const updateEquipmentType = (event, value) => {
    setState({...state, equipment: {...state.equipment, type: value}});
  };

  const updateAssignedCrew = (event, crew) => {
    console.log(crew)
    if (crew && crew._id) {
      setState({
        ...state,
        assignedCrew: crew,
        equipment: {
          ...state.equipment,
          crew: crew._id,
          crewName: crew.name,
          checkedOutTo: crew?.foreman || null,
          checkedOutToName: crew?.foremanName || '',
          isCheckedOut: true,
          lastCheckOutTime: new Date(),
          updated_at: new Date(),
        }
      });
    } else {
      setState({
        ...state,
        assignedCrew: {},
        equipment: {
          ...state.equipment,
          crew: null,
          crewName: 'None',
          checkedOutTo: null,
          checkedOutToName: null,
          isCheckedOut: false,
          updated_at: new Date()
        }
      });
    }
  };

  const handleUpdateAssignedEntity = (newEntity) => {
    if (newEntity && newEntity._id) {
      setState({...state, equipment: {...state.equipment, entity: newEntity._id }});
    } else {
      setState({...state, equipment: {...state.equipment, entity: null }});
    }
  };

  const handleUpdateResponse = (resp) => {
    if (resp && resp.filesUploaded && resp.filesUploaded.length) {
      let ourFile = resp.filesUploaded[0];
      let item = {...state.equipment};
      item.pictureURL = ourFile.url;
      setState({...state, equipment: item });
    }
  };

  const handleChangeStatus = (e) => {
    setState({...state, equipment: {...state.equipment, status: e.target.value }});
  };

  const handleAddRepair = (data) => {
    console.log('Add Repair..', data);
  };

  const handleLogMtc = () => {
    const route = `/vehiclemaintenance/${state.equipment._id}`;
    history.push({ pathname: route, props: { equipment: state.equipment }});
  };

  const handleToggleSprayTruck = async (isChecked) => {
    if (isChecked) {
      // User is enabling spray truck - we'll save tank config when they hit save
      setState({
        ...state,
        equipment: {
          ...state.equipment,
          isSprayTruck: true
        }
      });
    } else {
      // User is disabling spray truck - call API immediately
      try {
        const response = await axios.post(
          `${props.url}/api/equipment/toggleSprayTruck`,
          {
            equipmentId: state.equipment._id,
            isSprayTruck: false
          }
        );

        if (response.data.success) {
          props.notification({
            type: 'success',
            title: 'Spray Truck Deactivated',
            message: 'Equipment is no longer designated as a spray truck'
          });

          setState({
            ...state,
            equipment: {
              ...state.equipment,
              isSprayTruck: false
            },
            tankState: null,
            recentActivities: []
          });
        }
      } catch (error) {
        console.error('Error deactivating spray truck:', error);
        props.notification({
          type: 'error',
          title: 'Error',
          message: 'Failed to deactivate spray truck'
        });
      }
    }
  };

  const handleTankConfigChange = (field, value) => {
    setState({
      ...state,
      tankConfig: {
        ...state.tankConfig,
        [field]: parseFloat(value) || 0
      }
    });
  };


const renderVehicleFields = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Year"
          value={state.equipment.year || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, year: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Manufacturer"
          value={state.equipment.manufacturer || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, manufacturer: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label="Model"
          value={state.equipment.model || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, model: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="License Plate"
          value={state.equipment.plate || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, plate: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Mileage"
          value={state.equipment.mileage || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, mileage: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Next Service Mileage"
          value={state.equipment.nextServiceMileage || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, nextServiceMileage: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="VIN"
          value={state.equipment.vin || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, vin: e.target.value}})}
        />
      </Grid>

      {/* ============== Spray Truck Section ============== */}
      <Grid item xs={12}>
        <Divider style={{ margin: '16px 0' }} />
        <Typography variant="h6" style={{ marginBottom: 8 }}>
          Spray Truck Configuration
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Enabling spray truck will create Clean and Mix tanks for this vehicle
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.equipment.isSprayTruck || false}
              onChange={(e) => handleToggleSprayTruck(e.target.checked)}
              name="isSprayTruck"
              color="primary"
            />
          }
          label="Designate as Spray Truck"
        />
      </Grid>

      {state.equipment.isSprayTruck && (
        <>
          <Grid item xs={12}>
            <Box p={2} border={1} borderRadius={4} borderColor="primary.main" bgcolor="rgba(63, 81, 181, 0.05)">
              <Typography variant="subtitle1" gutterBottom color="primary">
                Tank Capacities & Calibration
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                {state.tankState
                  ? 'Update tank capacities or calibration rate for this spray truck'
                  : 'Configure the max capacity for Clean and Mix tanks (both start empty)'}
              </Typography>
              {state.tankState && (
                <Chip
                  label="Tanks Already Configured"
                  size="small"
                  color="primary"
                  style={{ marginBottom: 8 }}
                />
              )}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Clean Tank Capacity (gal)"
                    type="number"
                    value={state.tankConfig.cleanTankCapacity}
                    onChange={(e) => handleTankConfigChange('cleanTankCapacity', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Mix Tank Capacity (gal)"
                    type="number"
                    value={state.tankConfig.mixTankCapacity}
                    onChange={(e) => handleTankConfigChange('mixTankCapacity', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Calibration Rate (gal/acre)"
                    type="number"
                    value={state.tankConfig.calibrationRate}
                    onChange={(e) => handleTankConfigChange('calibrationRate', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Current Tank Status */}
          <Grid item xs={12}>
            <Box p={2} border={1} borderRadius={4} borderColor="grey.300">
              <Typography variant="subtitle1" gutterBottom>
                Current Tank Status
              </Typography>
              {state.loadingTankData ? (
                <Box display="flex" alignItems="center" justifyContent="center" p={3}>
                  <CircularProgress size={24} />
                  <Typography variant="body2" color="textSecondary" style={{ marginLeft: 12 }}>
                    Loading tank status...
                  </Typography>
                </Box>
              ) : state.tankState && state.tankState.tanks ? (
                <Grid container spacing={2}>
                  {state.tankState.tanks.map((tank, index) => (
                    <Grid item xs={12} sm={6} key={index}>
                      <Paper elevation={1} style={{ padding: 12 }}>
                        <Typography variant="caption" color="textSecondary">
                          {tank.type === 'clean' ? 'Clean Tank' : 'Mix Tank'}
                        </Typography>
                        <Typography variant="h6">
                          {tank.currentVolume.toFixed(1)} / {tank.maxCapacity} gal
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          ({((tank.currentVolume / tank.maxCapacity) * 100).toFixed(1)}% full)
                        </Typography>
                        {tank.hasChemicals && (
                          <Chip
                            label="Contains Chemicals"
                            size="small"
                            color="secondary"
                            style={{ marginTop: 4 }}
                          />
                        )}
                        {tank.contents?.filter(c => c.type === 'chemical').length > 0 && (
                          <Box mt={1}>
                            <Typography variant="caption" color="textSecondary">
                              Chemicals:
                            </Typography>
                            {tank.contents
                              .filter(c => c.type === 'chemical')
                              .map((chem, i) => (
                                <Typography key={i} variant="body2">
                                  • {chem.chemicalName} ({(chem.concentration || 0).toFixed(2)}%)
                                </Typography>
                              ))}
                          </Box>
                        )}
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No tank data available yet. Save this configuration to initialize tanks.
                </Typography>
              )}
            </Box>
          </Grid>

          {/* Recent Activities */}
          {(state.recentActivities.length > 0 || state.tankState) && (
            <Grid item xs={12}>
              <Box p={2} border={1} borderRadius={4} borderColor="grey.300">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="subtitle1">
                    Recent Tank Activities
                  </Typography>
                  {state.recentActivities.length > 0 && (
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => setState({ ...state, showAllActivities: true })}
                    >
                      View All
                    </Button>
                  )}
                </Box>
                {state.recentActivities.length > 0 ? (
                  state.recentActivities.slice(0, 5).map((activity, index) => (
                    <Box key={index} py={1} borderBottom={index < 4 ? '1px solid #eee' : 'none'}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="caption" color="textSecondary">
                            {moment(activity.timestamp).format('MMM DD, h:mm A')}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="body2">
                            {activity.employee}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2">
                            {activity.details}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No tank activities recorded yet. Activities will appear here after tank operations.
                  </Typography>
                )}
              </Box>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );

  const renderKeyFields = () => {
    // Render additional fields based on keyType
    const renderKeyTypeFields = () => {
      switch (state.equipment.keyType) {
        case 'Vehicle':
          return (
            <Grid item xs={12}>
              <Autocomplete
                id="vehicle-select"
                options={props?.equipmentList?.filter(item => item?.type === 'Vehicle') || []}
                getOptionLabel={(option) => formattedItem('vehicle', option)}
                value={state.equipment.keyForEquipment || null}
                onChange={(e, newValue) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyForEquipment: newValue
                  }
                })}
                renderInput={(params) => <TextField {...params} label="Select Vehicle" variant="outlined" />}
              />
            </Grid>
          );
        
        case 'Equipment':
          return (
            <Grid item xs={12}>
              <Autocomplete
                id="equipment-select"
                options={props?.equipmentList?.filter(item => item?.type !== 'Vehicle') || []}
                getOptionLabel={(option) => formattedItem('equipment', option)}
                value={state.equipment.keyForEquipment || null}
                onChange={(e, newValue) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyForEquipment: newValue
                  }
                })}
                renderInput={(params) => <TextField {...params} label="Select Equipment" variant="outlined" />}
              />
            </Grid>
          );
        
        case 'Customer Building':
          return (
            <Grid item xs={12}>
              <Autocomplete
                id="jobsite-select"
                options={props?.jobSites || []}
                getOptionLabel={(option) =>formattedItem('jobSite', option)}
                value={state.equipment.keyForJobSite || null}
                onChange={(e, newValue) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyForJobSite: newValue
                  }
                })}
                renderInput={(params) => <TextField {...params} label="Select Customer Building" variant="outlined" />}
              />
            </Grid>
          );
        
        case 'Company Building':
          return (
            <Grid item xs={12}>
              <TextField
                id="company-building"
                label="Company Building"
                variant="outlined"
                fullWidth
                value={state.equipment.keyDetails || ''}
                onChange={(e) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyDetails: e.target.value
                  }
                })}
              />
            </Grid>
          );
        
        case 'Other':
          return (
            <Grid item xs={12}>
              <TextField
                id="other-details"
                label="Other Details"
                variant="outlined"
                multiline
                rows={3}
                fullWidth
                value={state.equipment.keyDetails || ''}
                onChange={(e) => setState({
                  ...state, 
                  equipment: {
                    ...state.equipment,
                    keyDetails: e.target.value
                  }
                })}
              />
            </Grid>
          );
        
        default:
          return null;
      }
    };
  
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            id="KeyType"
            options={TypesOfKeys}
            onChange={(e, newOpt) => setState({
              ...state, 
              equipment: {
                ...state.equipment, 
                keyType: newOpt
              }
            })}
            value={state.equipment.keyType || ''}
            renderInput={(params) => <TextField {...params} label="Key Type" variant="outlined" />}
          />
        </Grid>
        
        {state.equipment.keyType && renderKeyTypeFields()}
        
        <Grid item xs={12}>
          <TextField
            id="notes"
            label="Notes"
            variant="outlined"
            multiline
            rows={2}
            fullWidth
            value={state.equipment.notes || ''}
            onChange={(e) => setState({
              ...state, 
              equipment: {
                ...state.equipment,
                notes: e.target.value
              }
            })}
          />
        </Grid>
      </Grid>
    );
  };

  const renderPhoneFields = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Phone Number"
          value={state.equipment.phoneNumber || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, phoneNumber: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="IMEI"
          value={state.equipment.imei || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, imei: e.target.value}})}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="MAC Address"
          value={state.equipment.mac || ''}
          onChange={(e) => setState({...state, equipment: {...state.equipment, mac: e.target.value}})}
        />
      </Grid>
    </Grid>
  );

  // Tank Activities Modal Component
  const TankActivitiesModal = () => {
    const [allActivities, setAllActivities] = React.useState([]);
    const [loadingAll, setLoadingAll] = React.useState(false);
    const [pagination, setPagination] = React.useState({ total: 0, limit: 50, skip: 0 });

    React.useEffect(() => {
      if (state.showAllActivities && state.equipment._id) {
        loadAllActivities();
      }
    }, [state.showAllActivities]);

    const loadAllActivities = async (skip = 0) => {
      setLoadingAll(true);
      try {
        const response = await axios.get(
          `${props.url}/api/equipment/getTankActivities?equipmentId=${state.equipment._id}&limit=50&skip=${skip}`
        );

        setAllActivities(response.data.activities || []);
        setPagination(response.data.pagination);
        setLoadingAll(false);
      } catch (error) {
        console.error('Error loading all activities:', error);
        setLoadingAll(false);
      }
    };

    const handlePageChange = (newSkip) => {
      loadAllActivities(newSkip);
    };

    return (
      <Dialog
        open={state.showAllActivities}
        onClose={() => setState({ ...state, showAllActivities: false })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          All Tank Activities - {state.equipment.name}
        </DialogTitle>
        <DialogContent>
          {loadingAll ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {allActivities.length === 0 ? (
                <Typography color="textSecondary">No activities found</Typography>
              ) : (
                <Box>
                  {allActivities.map((activity, index) => (
                    <Paper
                      key={index}
                      elevation={1}
                      style={{ padding: 12, marginBottom: 8 }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="caption" color="textSecondary">
                            Date/Time
                          </Typography>
                          <Typography variant="body2">
                            {moment(activity.timestamp).format('MMM DD, YYYY h:mm A')}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Typography variant="caption" color="textSecondary">
                            Employee
                          </Typography>
                          <Typography variant="body2">
                            {activity.employee}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="caption" color="textSecondary">
                            Activity
                          </Typography>
                          <Typography variant="body2">
                            {activity.details}
                          </Typography>
                        </Grid>
                        {activity.location && (
                          <Grid item xs={12}>
                            <Typography variant="caption" color="textSecondary">
                              Location: {activity.location.coordinates?.[1]?.toFixed(6)}, {activity.location.coordinates?.[0]?.toFixed(6)}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Paper>
                  ))}

                  {/* Pagination */}
                  {pagination.total > pagination.limit && (
                    <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                      <Button
                        disabled={pagination.skip === 0}
                        onClick={() => handlePageChange(Math.max(0, pagination.skip - pagination.limit))}
                      >
                        Previous
                      </Button>
                      <Typography variant="body2" style={{ margin: '0 16px' }}>
                        Showing {pagination.skip + 1} - {Math.min(pagination.skip + pagination.limit, pagination.total)} of {pagination.total}
                      </Typography>
                      <Button
                        disabled={!pagination.hasMore}
                        onClick={() => handlePageChange(pagination.skip + pagination.limit)}
                      >
                        Next
                      </Button>
                    </Box>
                  )}
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setState({ ...state, showAllActivities: false })}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <TankActivitiesModal />
    <Dialog fullScreen open={props.open} onClose={handleCloseModal}>
      <Box className={classes.header}>
        <IconButton className={classes.closeButton} onClick={handleCloseModal}>
          <CloseIcon />
        </IconButton>
        <Box className={classes.headerContent}>
          <CategoryIcon fontSize="large" />
          <Box>
            <Typography variant="h5">
              {state.equipment.name || 'Equipment Details'}
            </Typography>
            <Typography variant="subtitle1">
              #{state.equipment.number}
            </Typography>
          </Box>
        </Box>
      </Box>

      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={4}>
            <Paper className={classes.section}>
              <Box p={2}>
                <PhotoUploadComponent
                  message="Click Here to Add a Photo (Or Drop Image File Here)"
                  equipment={state.equipment}
                  updateParent={handleUpdateResponse}
                />
                <Box className={classes.imageSection}>
                  {state.equipment.pictureURL && (
                    <img
                      src={state.equipment.pictureURL}
                      alt={state.equipment.name}
                      className={classes.mainImage}
                    />
                  )}
                  {state.qrCode && (
                    <img
                      src={state.qrCode}
                      alt="QR Code"
                      className={classes.qrCode}
                    />
                  )}
                </Box>
                
                <TextField
                  select
                  fullWidth
                  label="Status"
                  value={state.equipment.status || ''}
                  onChange={handleChangeStatus}
                  variant="outlined"
                >
                  <MenuItem value="In Service">In Service</MenuItem>
                  <MenuItem value="Out for Repair">Out for Repair</MenuItem>
                  <MenuItem value="On Customer Site">On Customer Site</MenuItem>
                  <MenuItem value="On Loan">On Loan</MenuItem>
                </TextField>

                <Box className={classes.statCard} mt={2}>
                  <Avatar className={classes.statIcon}>
                    <SpeedIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="body2" color="textSecondary">
                      Current Mileage
                    </Typography>
                    <Typography variant="h6">
                      {state.equipment.mileage?.toLocaleString() || '0'} mi
                    </Typography>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    startIcon={<AssignmentIcon />}
                    onClick={handleLogMtc}
                    style={{ marginTop: 16 }}
                  >
                    Log Maintenance
                  </Button>
                  
                  <Box mt={1}>
                    <AddRepairButton 
                      equipmentId={state?.equipment._id} 
                      equipmentName={state?.equipment.name}
                      onAddRepair={handleAddRepair}
                    />
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper className={classes.section}>
              <Box p={2}>
                <Typography variant="h6" className={classes.sectionTitle}>
                  <BusinessIcon />
                  Organization
                </Typography>
                
                <Autocomplete
                  fullWidth
                  options={divisions}
                  value={state.equipment.division}
                  onChange={updateEquipmentDivision}
                  renderInput={(params) => (
                    <TextField {...params} label="Division" variant="outlined" />
                  )}
                />

                <Box mt={2}>
                  <Autocomplete
                    fullWidth
                    options={props.crews}
                    getOptionLabel={(option) => {
                      if (option?.name) {
                        return `${option.name}${option?.foremanName ? `(${option.foremanName})` : ''}`
                      } else {
                        return null
                      }
                    }}
                    value={state.assignedCrew}
                    onChange={updateAssignedCrew}
                    renderInput={(params) => (
                      <TextField {...params} label="Assigned Crew" variant="outlined" />
                    )}
                  />
                </Box>

                <Box mt={2}>
                  <AssignedEntityComponent 
                    entity={state.equipment.entity} 
                    title={'Assigned Entity'} 
                    disabled={loading} 
                    user={props.user} 
                    updateParent={handleUpdateAssignedEntity} 
                  />
                </Box>
              </Box>
            </Paper>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={8}>
            <Paper>

              <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Details" />
               { state.equipment.type !== 'Key' && <Tab label="Repair History" /> }
               { state.equipment.type !== 'Key' && <Tab label="Maintenance History" /> }
                { state.equipment.type !== 'Key' && <Tab label="Damage History" /> }
                <Tab label="Notes & Settings" />
              </Tabs>

              <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <CategoryIcon />
                    Basic Information
                  </Typography>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Equipment Name"
                        value={state.equipment.name || ''}
                        onChange={(e) => setState({...state, equipment: {...state.equipment, name: e.target.value}})}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        fullWidth
                        options={equipmentTypes}
                        value={state.equipment.type}
                        onChange={updateEquipmentType}
                        renderInput={(params) => (
                          <TextField {...params} label="Equipment Type" variant="outlined" />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    {state.equipment.type === 'Vehicle' ? <CarIcon /> : 
                     state.equipment.type === 'Cell Phone' ? <PhoneIcon /> : 
                     <BuildIcon />}
                    Equipment Details
                  </Typography>
                  
                  {(state?.equipment?.type === 'Trailer' || state.equipment.type === 'Vehicle') && renderVehicleFields()}
                  {state.equipment.type === 'Cell Phone' && renderPhoneFields()}
                  {state.equipment.type === 'Key' && renderKeyFields()}
                </Box>

                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    <LocationIcon />
                    Location Information
                  </Typography>
                  <TextField
                    fullWidth
                    label="Location"
                    value={state.equipment.location || ''}
                    onChange={(e) => setState({...state, equipment: {...state.equipment, location: e.target.value}})}
                  />
                </Box>
              </TabPanel>

              <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
                {(state.equipment._id && state.equipment.type !== 'Key') && (
                  <RepairComponent equipmentId={state.equipment._id} url={props.url} equipmentName={state.equipment.name} />
                )}
              </TabPanel>
              <TabPanel value={tabValue} index={2} className={classes.tabPanel}>
              {state.equipment._id && (
                  <EquipmentMaintenanceHistory 
                    equipmentId={state.equipment._id}
                    url={props.url}
                    perms={props.user?.permissions || []}
                  />
                )}
              </TabPanel>
              <TabPanel value={tabValue} index={3} className={classes.tabPanel}>
              {state.equipment._id && (
                  <VehicleDamageViewer 
                    equipmentId={state.equipment._id}
                    url={props.url}
                  />
                )}
              </TabPanel>
              <TabPanel value={tabValue} index={state?.equipment?.type === 'Key' ? 1 : 4} className={classes.tabPanel}>
                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Notes
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Equipment Notes"
                    value={state.equipment.notes || ''}
                    onChange={(e) => setState({...state, equipment: {...state.equipment, notes: e.target.value}})}
                  />
                </Box>

                <Box className={classes.fieldGroup}>
                  <Typography variant="h6" className={classes.sectionTitle}>
                    Settings
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.isActive}
                        onChange={(e) => setState({
                          ...state,
                          isActive: !state.isActive,
                          equipment: {...state.equipment, isActive: !state.isActive}
                        })}
                      />
                    }
                    label={state.isActive ? 'Equipment Active' : 'Equipment Inactive'}
                  />
                </Box>

                  <Box className={classes.fieldGroup}>
                    <Typography variant="h6" className={classes.sectionTitle}>
                      QR Code
                    </Typography>
                    <TextField
                      fullWidth
                      label="Custom QR Code"
                      value={state.equipment.qrCode || ''}
                      onChange={(e) => setState({
                        ...state,
                        customQR: e.target.value,
                        equipment: {...state.equipment, qrCode: e.target.value}
                      })}
                    />
                  </Box>
          
              </TabPanel>
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  notification: state.notification
});

export default connect(mapStateToProps)(EquipmentModal);
